/**
 * Helper per gestire risposte 400 "Impossibile eliminare: oggetto usato altrove"
 * restituite dal backend quando l'utente tenta di eliminare entità protette
 * da on_delete=PROTECT (Punto 5 feedback cliente).
 *
 * Il backend risponde:
 * {
 *   error: "Impossibile eliminare: oggetto usato altrove.",
 *   dipendenze: [
 *     { modello: "Ordine", count: 3, esempi: ["ORD-2026-012", ...] },
 *     ...
 *   ]
 * }
 */

export function estraiDipendenze(error) {
  const data = error?.response?.data
  if (!data || !Array.isArray(data.dipendenze)) return null
  return { message: data.error, dipendenze: data.dipendenze }
}

export function formatDipendenzeMessage(parsed) {
  if (!parsed) return null
  const righe = parsed.dipendenze.map((d) => {
    const esempi = d.esempi?.length ? ` (es. ${d.esempi.join(', ')})` : ''
    return `• ${d.modello}: ${d.count} riferiment${d.count === 1 ? 'o' : 'i'}${esempi}`
  })
  return `${parsed.message}\n\n${righe.join('\n')}`
}
